import React from 'react';
import { useHistory } from 'react-router-dom';

import Button from 'shared-components/Button/Button';
import styles from './EmptyCart.module.css';

const EmptyCart = () => {
  const history = useHistory();
  const handleClick = () => history.push('/shop/');

  return (
    <div className={styles.container}>
      <i className="fal fa-box-open" />
      <h3>Your Cart is Empty</h3>
      <p>Treat yourself and start shopping!</p>
      <Button onClick={handleClick} style={{ width: 230, marginTop: 24 }}>
        Go to the shop
      </Button>
    </div>
  );
};

export default EmptyCart;
